import React from 'react';
import {View, iURL} from 'MWC';
import mainTpl from '../templates/main';
import PropTypes from 'prop-types';
import cookie from '../../../../helpers/vendor/cookie';
import GreenCardsModel from '../../../Cards/models/greenCards.m';
import {apiback} from '../../../../config';
import {SECTION_TARIFFS} from '../../../GreenCard/constants';
import widgetsHelper from 'utils/getWidget.helper';

const utmMarks = [
        'utm_manager',
        'utm_source',
        'utm_comment',
        'utm_campaign',
        'utm_medium',
        'utm_term',
        'utm_content'
    ],
    greenCard = 'green_card',
    CPA_PROGRAM_SOURCE = 'CPA',
    REFERAL_PROGRAM_SOURCE = 'REFERAL';

class Main extends View {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.tariffsElement = React.createRef();
        this.widgetsHelper = widgetsHelper;

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            isUtm: new URLSearchParams(this.props.location.search).get('utm_source'),
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            where_by_2: ['path'],
            search_by_2: ['/cards/vygoda/tab3'],
            widgets_2: [],
            textAboveFooterData: '',
            tooltipDisplay: false,
            tooltipElement: null,
            loader: true
        };
    }

    componentWillMount() {
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new GreenCardsModel(json.data[greenCard])
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    componentWillReady(resolve) {
        this.addTooltipListeners();
        this.utmParams = this.saveUTMParams();
        resolve();

        this.widgetsHelper.getWidgets.call(this);
        this.widgetsHelper.getWidgets_2.call(this);
    }

    componentReady() {
        const {section} = this.props.match?.params;

        if (section === SECTION_TARIFFS) {
            this.tariffsElement.current?.scrollIntoView({behavior: 'smooth'});
        }
    }

    addTooltipListeners() {
        const tooltip = document.getElementsByClassName('tooltip')[0];
        if (!tooltip.hasAttribute('listener')) {
            tooltip.setAttribute('listener', 'true');
            tooltip.addEventListener('mouseenter', e => {
                if (!this.state.tooltipDisplay) {
                    this.setTooltip(true, e);
                }
            });
            tooltip.addEventListener('mouseleave', () => {
                if (this.state.tooltipDisplay) {
                    this.setTooltip(false);
                }
            });
            tooltip.addEventListener('click', e => {
                this.setTooltip(true, e);
            });
            document.addEventListener('click', e => {
                const classList = e.target.classList;
                if (!classList.contains('tooltip') && !classList.contains('tooltip_img')) {
                    this.setTooltip(false);
                }
            });
        }
    }

    componentDidUpdate() {
        this.addTooltipListeners();
    }

    componentWillUnmount() {
        const tooltip = document.getElementsByClassName('tooltip')[0];
        tooltip.removeEventListener('mouseenter', () => {});
        tooltip.removeEventListener('mouseleave', () => {});
        tooltip.removeEventListener('click', () => {});
        document.removeEventListener('click', () => {});
    }

    setTooltip(display, e) {
        if (e) {
            this.setState({tooltipElement: e.currentTarget});
        }
        this.setState({tooltipDisplay: display});
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    saveUTMParams() {
        const params = iURL.getSearchParams();
        let result = {};

        if (params.utm_source === REFERAL_PROGRAM_SOURCE) {
            result = this._getUTMMarks(params);
        } else if (params.utm_source === CPA_PROGRAM_SOURCE) {
            result = this._setUTMMarks(params);
            this.props.history.push(this.props.location.pathname);
        } else if (cookie('utm_source') === CPA_PROGRAM_SOURCE) {
            result = this._getUTMMarks();
        }

        return result;
    }

    _getUTMMarks(storage = cookie) {
        const result = {};

        for (const name of utmMarks) {
            if (storage === cookie) {
                result[name] = cookie(name) || '';
            } else {
                result[name] = storage[name] || '';
            }
        }

        return result;
    }

    _setUTMMarks(data = {}) {
        for (const name of utmMarks) {
            if (data[name]) {
                cookie(name, data[name], {expires: 30, path: '/'});
            } else {
                cookie(name, null, {path: '/'});
            }
        }

        return data;
    }

    static contextTypes = {
        app: PropTypes.object
    };

    static displayName = 'GreenCard.Views.Main';
}

export default Main;
